// Google Analytics 4 - Site clips-on.ch
// Chargement conditionné au consentement cookies (voir CookieConsent.tsx)

const GA_MEASUREMENT_ID = "G-1RJK6VR7VR"

declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}

let isLoaded = false

/**
 * Charge dynamiquement gtag.js et initialise GA4.
 * N'a aucun effet si déjà chargé.
 */
export function loadGoogleAnalytics() {
  if (isLoaded || typeof window === "undefined") return
  if (document.getElementById("ga4-gtag-script")) {
    isLoaded = true
    return
  }

  window.dataLayer = window.dataLayer || []
  function gtag() {
    // @ts-ignore - snippet officiel Google : doit utiliser `arguments`, pas de rest params
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag

  const script = document.createElement("script")
  script.id = "ga4-gtag-script"
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.gtag("js", new Date())
  // send_page_view désactivé ici : on envoie manuellement les page_view
  // à chaque changement de route (voir usePageTracking)
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false })

  isLoaded = true
}

/**
 * Envoie un événement page_view à GA4 (premier chargement + changements de route).
 * Sans effet si GA n'est pas chargé (consentement non donné).
 */
export function trackPageView(path: string) {
  if (!isLoaded || typeof window === "undefined" || !window.gtag) return
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  })
}

export function isAnalyticsLoaded() {
  return isLoaded
}
